import React, {
  useContext,
  useEffect,
} from 'react';
import classNames from 'classnames';

import { Pagesection, Progress, Loading } from '@ktag/styleguide/dist/react';

import {
  FormConfigStore,
  MunicipalitySelection,
  MunicipalityStore,
  AppOrderFinal,
  HocCreateOrder,
  SupportForm
} from 'ewp-common';

import Payment from '../../payment/react/Payment';
import Step1 from '../../step1/react/Step1';
import withBaseForm, { PropsFromBaseForm } from '../../withBaseForm/react/withBaseForm';

interface Props extends PropsFromBaseForm {
  id?: string;
  className?: string;
  additionalClassNames?: string;
}

const OrderResidencyCertForm = (props: Props) => {
  const {
    id,
    className,
    additionalClassNames,
    activeRoute,
    setRoute,
  } = props;

  const {
    state: formConfigState,
    fetchFormConfig,
  } = useContext(FormConfigStore.FormConfigContext);

  const {
    state: municipalityState,
    fetchMunicipalityDetails,
  } = useContext(MunicipalityStore.MunicipalityContext);

  const configs = formConfigState?.data?.labelsMap;

  useEffect(() => {
    fetchFormConfig(municipalityState.selectedMunicipality?.data?.gemeinde?.gemeinde_ID);
    const currentUrl = window.location.search;
    const urlParams = new URLSearchParams(currentUrl);
    const municipalityId = urlParams.get('municipalityId');
    if(municipalityId){
      fetchMunicipalityDetails(municipalityId);
      setRoute(2);
    }
  }, []);

  SupportForm.supportForm(
    municipalityState.selectedMunicipality?.data?.gemeinde?.gemeinde_Name ?? '',
    process.env.REACT_APP_NAME,
    activeRoute,
    '',
    configs?.processName?.labelDisplayName,
    process.env.REACT_APP_SERVICE_ID
  );

  

  return (
    <div id={id} className={classNames(className, additionalClassNames)}>
      <Pagesection>
      {formConfigState.isLoading && <Loading size="verysmall" />}
      { !formConfigState.isLoading
                    && configs
        && (
        <>
          <h1 className="pagetitle">{configs.processName.labelDisplayName}</h1>
          <Progress
            items={[
              {
                isDone: activeRoute > 1,
                isActive: activeRoute === 1,
                label: configs.step1Title?.labelDisplayName,
                onClick: function noRefCheck() {
                  if (activeRoute >= 1 && activeRoute <= 3) {
                    setRoute(1);
                  }
                },
                step: 1,
              },
              {
                isDone: activeRoute > 2,
                isActive: activeRoute === 2,
                label: configs.step2Title?.labelDisplayName,
                onClick: function noRefCheck() {
                  if (activeRoute >= 2 && activeRoute <= 3) {
                    setRoute(2);
                  }
                },
                step: 2,
              },
              {
                isDone: activeRoute > 3,
                isActive: activeRoute === 3,
                label: configs.step3Title?.labelDisplayName,
                onClick: function noRefCheck() {
                  if (activeRoute === 3) {
                    setRoute(3);
                  }
                },
                step: 3,
              },
              {
                isDone: activeRoute > 4,
                isActive: activeRoute === 4,
                label: configs.step4Title?.labelDisplayName,
                onClick: function noRefCheck() {
                  if (activeRoute === 4) {
                    setRoute(4);
                  }
                },
                step: 4,
              },
            ]}
          />

          {/* <section data-supportmenu=""
            data-translation-api={process.env.REACT_APP_DATA_TRANSLATION_API}
            data-translation-missing-api={process.env.REACT_APP_DATA_TRANSLATION_MISSING_API}
            data-form-app-manifest-url={process.env.REACT_APP_DATA_FORM_APP_MANIFEST_URL}
            data-form-app-root-node={process.env.REACT_APP_DATA_FORM_APP_ROOT_NODE}
            data-form-backend-api={process.env.REACT_APP_DATA_FORM_BACKEND_API}
            data-form-recaptcha-api-key={process.env.REACT_APP_DATA_FORM_RECAPTCHA_API_KEY}
            disabled-data-translation-api={process.env.REACT_APP_DISABLED_DATA_TRANSLATION_API}
            disabled-data-form-app-manifest-url={process.env.REACT_APP_DISABLED_DATA_FORM_APP_MANIFEST_URL}>
          </section> */}

          {activeRoute === 1 && (
          <MunicipalitySelection
            labelConfig={configs}
            formSubmit={() => setRoute(2)}
          />
          )}
          {activeRoute === 2 && <Step1 setRoute={setRoute} />}
          {activeRoute === 3 && <HocCreateOrder component={Payment} setRoute={setRoute} />}
          {activeRoute === 4 && <AppOrderFinal />}
        </>
        )}
        </Pagesection>
      {/* <Footer {...footerConfig} /> */}

    </div>
  );
};

OrderResidencyCertForm.defaultProps = {
  id: '',
  className: 'orderResidencyCertForm',
  additionalClassNames: '',
};

export default withBaseForm(OrderResidencyCertForm);
